import { useEffect, useState } from 'react';
import type { Brand, BrandColorItem } from '@models/brand.model';
import { OrganizationService } from '@services/organizations/OrganizationService';
import { BRAND_IDENTITY_V2, useFeatureFlag } from '@/shared/featureFlags/useFeatureFlag';

/**
 * The brand's unified color list for the editor's swatches (MPN-2031), so every color saved
 * on the Branding tab is in every color picker. Null while brand-identity-v2 is off, until
 * the list arrives, or if it can't be read: the AssetKit then keeps the legacy color columns.
 */
export function useBrandColors(organizationId: string, brand: Brand | null): BrandColorItem[] | null {
  const brandIdentityV2 = useFeatureFlag(BRAND_IDENTITY_V2);
  const [colors, setColors] = useState<BrandColorItem[] | null>(null);
  const brandId = brand?.id;

  useEffect(() => {
    setColors(null);
    if (!brandIdentityV2 || !brandId || organizationId === '-1') return;
    let live = true;
    new OrganizationService().getBrandColors(organizationId, brandId).then(
      (items) => { if (live) setColors(items); },
      () => {},
    );
    return () => { live = false; };
  }, [brandIdentityV2, organizationId, brandId]);

  return colors;
}
